<ejs-dropdownlist
  id="organizationField"
  #organizationField
  [enabled]="!disabled"
  [dataSource]="options"
  [fields]="fields"
  [enableVirtualization]="true"
  (change)="onOrganizationChanged($event)"
  cssClass="e-outline"
  [allowFiltering]="true"
  [noRecordsTemplate]="'No Orgs Found'"
  [filterType]="'contains'"
  [placeholder]="'General.SelectOrganization' | translate"
  >
</ejs-dropdownlist>
<div *ngIf='loading' class="spinner-overlay">
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
